import * as React from 'react'
import { generateText } from 'src/shared/utils/helpers'


export const COLLAR_KI_KO_payoffInfo = (data?: any) => (
    <>
        <p className="gutterBottom payoff-info">
            À chaque date de constatation du fixing (avec une périodicité {generateText(data,"periodicite","périodicité")} à partir de la mise en place, et ce, pendant {generateText(data,"duree_de_la_couverture","durée_couverture")} mois),
        </p>
        <p className="gutterBottom payoff-info">
            Si l’indice {generateText(data,"indice_sous_jacent","l'indice sous jacent")} constaté est inférieur {generateText(data,"strike_ki","strike_KI")}% (strike d’activation), vous payez un taux fixe égal à {generateText(data,"strike_floor","strike_floor")}% (taux du FLOOR*)
        </p>
        <p className="gutterBottom payoff-info">
            Si l’indice {generateText(data,"indice_sous_jacent","l'indice sous jacent")} constaté est supérieur ou égal à {generateText(data,"strike_ki","strike_KI")}% (strike d’activation) et inférieur à {generateText(data,"strike_cap","strike_CAP")}% (strike plafond), vous payez un taux variable* indexé sur {generateText(data,"indice_sous_jacent","l'indice sous jacent")}.
        </p>
        <p className="gutterBottom payoff-info">
            Si l’indice {generateText(data,"indice_sous_jacent","l'indice sous jacent")} constaté est supérieur ou égal à {generateText(data,"strike_cap","Strike CAP")}% (strike plafond) et inférieur ou égal à {generateText(data,"strike_floor","strike_floor")}% (strike de désactivation), vous payez un taux fixe égal {generateText(data,"strike_cap","strike_CAP")}% (taux du CAP*)
        </p>
        <p className="gutterBottom payoff-info">
            Si l’indice {generateText(data,"indice_sous_jacent","l'indice sous jacent")} constaté est supérieur à {generateText(data,"strike_floor","strike_floor")}% (strike de désactivation), vous payez un taux variable* indexé sur l’indice {generateText(data,"indice_sous_jacent","l'indice sous jacent")}.
        </p>
        <p className="gutterBottom payoff-info">*: les taux indiqués s’entendent net d’un éventuel coût de la prime de couverture et de la marge de crédit (spread)</p>
    </>
)



// WEBPACK FOOTER //
// ./src/shared/Cotation/describe/CollarKIKO.tsx